import type {ReactNode} from "react";
import type {OttopilotDataViewerController} from "~/components/ottopilotDataViewer/ottopilotDataViewerController";
import {useListViewRows} from "~/components/ottopilotDataViewer/viewDataHooks";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/**
 * Encapsulates list-view paginated row fetching (not {@link useTableRows}).
 * Use this render-prop wrapper when you need list data outside {@link ListView}.
 * (Previously infinite-scroll; name kept for call-site compatibility.)
 */
export function ListViewInfiniteRows<T extends {id: Uuid}>({
    controller,
    children,
}: {
    controller: OttopilotDataViewerController<T>;
    children: (rowsQuery: ReturnType<typeof useListViewRows<T>>) => ReactNode;
}) {
    const rowsQuery = useListViewRows(controller);
    return <>{children(rowsQuery)}</>;
}
